import React from 'react';
import Container from 'Nori/Container';
import styles from 'Custom/Table/SideEffectsTable.module.scss';
import RichText from 'Custom/RichText';
import ConditionIcon from 'Images/brand-icons/condition-icon.svg';

const TABLE_VARIANTS = {
  simple: styles.simple,
  default: '',
};

const SideEffectsTable = ({
  className = '',
  variant = '',
  content = [],
  showIcon = false,
  footnote = null,
  children,
  ...props
}) => {
  const variantClassName = TABLE_VARIANTS[variant] || TABLE_VARIANTS.default;
  const containerSize = variant === TABLE_VARIANTS.default ? 'md' : '';

  return (
    <section
      className={`${styles.sideEffectsTable} ${variantClassName} ${className}`}
      {...props}
    >
      <Container size={containerSize} className={styles.sideEffectsCopy}>
        {children}
      </Container>
      <Container>
        <div className={styles.tableWrapper}>
          {content.map((cell, index) => (
            <div key={`cell-${index}`} className={styles.tableCell}>
              {showIcon && <ConditionIcon />}
              <h4 className={styles.tableCellTitle}>{cell}</h4>
            </div>
          ))}
        </div>
      </Container>
      {/* {footnote && ( */}
      <Container size="md" className={styles.sideEffectsFootnote}>
        <RichText>{footnote}</RichText>
      </Container>
      {/* )} */}
    </section>
  );
};

export default SideEffectsTable;
